import t from 'tcomb';
import every from 'lodash/collection/every';
import sortBy from 'lodash/collection/sortBy';
import Register_Country from './Register_Country';

// # Tabella dei paesi
// Contiene i valori per l'area, la valuta e il bonus per ogni paese
// più alcune funzioni utili di formattazione
const countries = {
  data: {
    AT: {
      area: '43',
      currency: 'EUR',
      bonus: 0
    },
    BR: {
      area: '55',
      currency: 'BRL',
      bonus: 0
    },
    FR: {
      area: '33',
      currency: 'EUR',
      bonus: 0
    },
    DE: {
      area: '49',
      currency: 'EUR',
      bonus: 0
    },
    GB: {
      area: '44',
      currency: 'GBP',
      bonus: 0
    },
    IT: {
      area: '39',
      currency: 'EUR',
      bonus: 0
    },
    ES: {
      area: '34',
      currency: 'EUR',
      bonus: 0
    },
    US: {
      area: '1',
      currency: 'USD',
      bonus: 0
    },
    CA: {
      area: '1',
      currency: 'CAD',
      bonus: 0
    },
    ZA: {
      area: '27',
      currency: 'ZAR',
      bonus: 0
    },
    CH: {
      area: '41',
      currency: 'CHF',
      bonus: 0
    }
  },

  currency: function(country) {
    return countries.data[country].currency;
  },

  area: function(country) {
    return countries.data[country].area;
  },

  bonus: function(country) {
    return countries.data[country].bonus;
  },

  format_area: function(locale, country) {
    return locale.display_country(country) + ' (+' + countries.area(country) + ') ';
  },

  format_mobile: function(country, mobile) {
    return '(+' + countries.area(country) + ') ' + mobile;
  },

  to_options: function(locale) {
    return sortBy(Object.keys(countries.data).map((k) => {
      return [
        k,
        locale.display_country(k)
      ];
    }), '1');
  }
};

// mi assicuro che ogni country abbia i suoi dati
t.assert(every(Register_Country.meta.map, function(country) {
  return countries.data.hasOwnProperty(country);
}));


module.exports = countries;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/countries.js
 **/